import * as React from "react";

import "./ai-error-modal.scss";

import { cs }                                            from "@Common/react/chain-services";
import {ModalService3}                                   from "@Common/ui-components/modal-service-3/modal-service-3";
import {UseState}                                        from "@Common/react/use-state";
import {consumeContext}                                  from "@Common/react/context";
import { ButtonSpinner }                                 from "loading-spinners/button-spinner";


export const AiErrorModal = ({ regen, next: rootNext }) => cs(
    ["modal", ({}, next) => ModalService3({
        next: ({close}) => next({close}),
        xToClose: true,
        ignorePassiveClose: true,
        rootNext,
        contentClassName: 'ai-error-modal-3b6',
        xdQaName: "AiErrorModal",
    })],
    ["generatingText", ({}, next) => UseState({initValue: false, next})],
    consumeContext("apis"),
    ({modal, generatingText}) => (
        <>
            <div className="confirmation-modal-14o">
                <div className="message">
                    {generatingText.value ? "Regenerating text..." : "Text generation is taking a while. If you wish to continue, please click \"Let's Try Again.\""}
                </div>
                {!generatingText.value ?
                <div className="footer">
                    <div className="line">
                        <button
                            className="proceed" onClick={async () => {
                                generatingText.onChange(true)
                                let response = await regen(false);
                                if(response) {
                                    modal.close();
                                } else {
                                    generatingText.onChange(false);
                                }
                            }}
                            xd-qa-type="button"
                        >Let's Try Again</button>
                    </div>
                    <div className="line">
                        <button
                            className="cancel"  onClick={ modal.close }
                            xd-qa-type="button"
                        >Cancel</button>
                    </div>
                </div>
                : <div className="button-container-3b6"><ButtonSpinner size={50} spinnerColor="black"/></div>}
            </div>
        </>
    )

)